export default __webpack_public_path__ + "static/media/ic_tracking_pause.b0e6a269.svg";